module.exports = __webpack_public_path__ + "static/img/bannar1.5c36d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannar1.png
// module id = n72U
// module chunks = 1